import { inject } from '@angular/core';
import { injectMutation } from '@tanstack/angular-query-experimental';

import {
  CreateSitePaymentScheduleInput,
  createSitePaymentScheduleMutation,
  GqlService,
  UpdateSitePaymentScheduleInput,
  updateSitePaymentScheduleMutation,
} from '@shared/services/gql.service';
import { OverlayService } from '@shared/services/overlay.service';
import { batchPromises } from '@shared/utils';
import { gqlToPromise } from '@shared/utils/gql-to-promise';

export const injectCreateSitePaymentScheduleMutation = () => {
  const gqlService = inject(GqlService);
  const overlayService = inject(OverlayService);

  return injectMutation(() => ({
    mutationFn: ({
      paymentsToCreate,
    }: {
      paymentsToCreate: CreateSitePaymentScheduleInput[];
      siteBudgetVersionId: string;
      siteId: string;
    }) => {
      const promises: Promise<createSitePaymentScheduleMutation | null>[] = paymentsToCreate.map(
        (payment) => gqlToPromise(() => gqlService.createSitePaymentSchedule$(payment))
      );

      return batchPromises(promises, (params) => params, 10, true);
    },
    onError: (error: Error) => {
      overlayService.error(error.message);
    },
  }));
};

export const injectUpdateSitePaymentScheduleMutation = () => {
  const gqlService = inject(GqlService);
  const overlayService = inject(OverlayService);

  return injectMutation(() => ({
    mutationFn: ({ paymentsToUpdate }: { paymentsToUpdate: UpdateSitePaymentScheduleInput[] }) => {
      const promises: Promise<null | updateSitePaymentScheduleMutation>[] = paymentsToUpdate.map(
        (payment) => gqlToPromise(() => gqlService.updateSitePaymentSchedule$(payment))
      );

      return batchPromises(promises, (params) => params, 10, true);
    },
    onError: (error: Error) => {
      overlayService.error(error.message);
    },
  }));
};
